export const en = {
    common: {
        save: "Save",
        saving: "Saving...",
        saved: "Saved",
        cancel: "Cancel",
        delete: "Delete",
        actions: "Actions",
        signOut: "Sign Out",
        email: "Email",
        password: "Password",
        name: "Name",
        organisation: "Organisation",
        optional: "(optional)",
        upload: "Upload",
        uploading: "Uploading…",
        create: "Create",
        close: "Close",
        search: "Search",
        loading: "Loading...",
        rename: "Rename",
        share: "Share",
        errorTryAgain: "An error occurred. Please try again.",
        assistant: "Assistant",
        edit: "Edit",
        confirm: "Confirm",
    },

    sidebar: {
        assistant: "Assistant",
        projects: "Projects",
        tabularReview: "Tabular Review",
        laura: "LAURA",
        workflows: "Workflows",
        accountSettings: "Account Settings",
        assistantHistory: "Assistant History",
        noChatsYet: "No chats yet",
        openSidebar: "Open sidebar",
        closeSidebar: "Close sidebar",
    },

    projects: {
        title: "Projects",
        searchPlaceholder: "Search projects…",
        tabAll: "All",
        tabMine: "Mine",
        tabSharedWithMe: "Shared with me",
        colName: "Name",
        colCm: "CM",
        colFiles: "Files",
        colChats: "Chats",
        colTabularReviews: "Tabular Reviews",
        colCreated: "Created",
        emptyDescription:
            "Upload documents into projects and to commence chats and tabular reviews with them.",
        createNew: "+ Create New",
        couldNotLoad: "Could not load projects.",
        noTabProjects: "No {tab} projects",
        newProjectTitle: "Projects › New project",
        projectName: "Project name",
        addCmNumber: "Add a CM number...",
        selectProject: "Select project…",
        noProjectsFound: "No projects found",
    },

    assistant: {
        greeting: "Hi, {username}",
        disclaimer: "AI can make mistakes. Answers are not legal advice.",
    },

    account: {
        profileTitle: "Profile",
        displayName: "Display Name",
        displayNamePlaceholder: "Enter your name",
        organisationLabel: "Organisation",
        organisationPlaceholder: "Enter your organisation",
        emailLabel: "Email",
        usagePlanTitle: "Usage Plan",
        actionsTitle: "Actions",
        dangerZoneTitle: "Danger Zone",
        dangerZoneDesc:
            "Permanently delete your account and all associated data. This action cannot be undone.",
        deleteAccount: "Delete Account",
        confirmDeleteQuestion:
            "Are you sure? This will permanently delete your account.",
        deleting: "Deleting…",
        languageTitle: "Language",
        languageLabel: "Display Language",
        modelsTitle: "Models",
    },

    auth: {
        logInTitle: "Log In",
        logIn: "Log in",
        signUp: "Sign up",
        createAccountTitle: "Create Account",
        emailPlaceholder: "Enter your email",
        passwordLabel: "Password",
        passwordPlaceholder: "Enter your password",
        createPasswordPlaceholder: "Create a password (min. 6 characters)",
        confirmPasswordLabel: "Confirm Password",
        confirmPasswordPlaceholder: "Confirm your password",
        namePlaceholder: "Your name",
        organisationPlaceholder: "Your organisation",
        passwordsMustMatch: "Passwords do not match",
        passwordTooShort: "Password must be at least 6 characters",
        accountCreatedTitle: "Account created!",
        accountCreatedRedirecting: "Redirecting you to the home page...",
        loggingIn: "Logging in...",
        creatingAccount: "Creating account...",
        demoDisclaimer:
            "Mike hosted on AuditFlow.com is currently a demo service. Please do not upload, submit, or store sensitive, confidential, privileged, client, or personally identifiable documents.",
        termsPrefix: "By signing up, you agree to our",
        termsLink: "Terms of Use",
        privacyLink: "Privacy Policy",
        termsConjunction: "and",
    },

    modals: {
        deleteChatsTitle: "Delete All Chats",
        deleteChatsConfirm:
            "Are you sure you want to delete all {count} {chatWord}? This action is permanent and cannot be undone.",
        deleteChatsButton: "Delete All Chats",
        deletingChats: "Deleting...",
        allChatsDeletedTitle: "All Chats Deleted",
        allChatsDeletedDesc:
            "Your chat history has been successfully deleted.",
        chat_one: "chat",
        chat_other: "chats",
        ownerOnlyTitle: "Owner Only",
        ownerOnlyDesc:
            "You can only {action}. Contact the project owner for access.",
        dismiss: "Dismiss",
        apiKeyMissingTitle: "API Key Required",
        copyLink: "Copy Link",
        linkCopied: "Copied!",
        shareLink: "Share Link",
        creditsTitle: "Message Limit Reached",
        creditsBody: "You've reached your monthly message limit of 100 messages.",
        creditsReset: "Your credits will reset on:",
        creditsInfo: "Your message credits automatically reset on the first day of each month.",
    },

    tabular: {
        newReviewPlaceholder: "Review name",
        workflowTemplate: "Workflow Template",
        loadingTemplates: "Loading templates…",
        noTemplate: "No template — start from scratch",
        createUnderProject: "Create under a project",
        selectDocuments: "Select Documents",
        projectDocuments: "Project Documents",
        documents: "Documents",
        noReadyDocs: "No ready documents in this project",
        noDocs: "No documents yet",
        tabularReviews: "Tabular Reviews",
        newReview: "New review",
        generate: "Generate",
        generating: "Generating…",
        addColumn: "+ Add Column",
        addDocuments: "+ Add Documents",
        clearAll: "Clear All",
        exportExcel: "Export to Excel",
        flag: "Flag",
        results: "Results",
        reasoning: "Reasoning",
        regenerate: "Regenerate",
        columnName: "Column Name",
        columnPrompt: "Prompt",
        columnFormat: "Format",
        saveColumn: "Save",
        deleteColumn: "Delete Column",
        noColumns: "No columns yet",
        noDocuments: "No documents",
        statusPending: "Pending",
        statusGenerating: "Generating",
        statusDone: "Done",
        statusError: "Error",
        run: "Run",
        running: "Running…",
        export: "Export",
        assistantInTabular: "Assistant in Tabular Review",
        clearResults: "Clear results",
        addColumns: "Add Columns",
        columnsSelected: "{count} columns selected",
        runColumn: "Run column",
        runSelectedColumnsHint: "Run selected columns for all documents (or selected rows)",
        runSelectedRowsHint: "Run all pending columns for selected documents",
        searchDocuments: "Search documents…",
        untitledReview: "Untitled Review",
        tabularReview: "Tabular Review",
        editColumn: "Edit column",
        newColumn: "New column",
        noPreset: "No Preset",
        tags: "Tags",
        addTag: "Add tag…",
        addTagHint: "Press Enter or comma to add a tag.",
        autoGeneratePrompt: "Auto-Generate Prompt",
        columnPromptPlaceholder: "Write the analysis prompt — describe what AuditFlow should extract from each document for this column…",
        addAnotherColumn: "Add another column",
        saveChanges: "Save changes",
        thinking: "Thinking…",
        pondering: "Pondering…",
        analyzing: "Analyzing…",
        reasoningVerb: "Reasoning…",
        thoughtProcess: "Thought process",
        reading: "Reading",
        read: "Read",
        chatPlaceholder: "Ask a question about your documents...",
        chatHistory: "Chat history",
        newChat: "New chat",
        deleteChat: "Delete chat",
        askQuestion: "Ask a question about this tabular review.",
        searchChats: "Search chats…",
        noPreviousChats: "No previous chats.",
        noMatches: "No matches.",
        chatFallback: "Chat",
    },

    workflows: {
        title: "Workflows",
        searchPlaceholder: "Search workflows…",
        tabAll: "All Workflows",
        tabBuiltin: "Built-in",
        tabCustom: "Custom",
        tabHidden: "Hidden",
        newWorkflow: "New Workflow",
        importWorkflows: "Import",
        colName: "Name",
        colType: "Type",
        colCreator: "Creator",
        typeAssistant: "Assistant",
        typeTabular: "Tabular",
        builtIn: "Built-in",
        noWorkflows: "No workflows found",
        workflowName: "Workflow name",
        workflowPrompt: "System Prompt",
        practiceArea: "Practice Area",
        allPractices: "All",
        allTypes: "All Types",
        hide: "Hide",
        unhide: "Unhide",
        colPractice: "Practice",
        colSource: "Source",
        filterByType: "Filter by type",
        filterByPractice: "Filter by practice",
        customWorkflowsTitle: "Custom Workflows",
        customWorkflowsDesc: "Build reusable prompts and tabular review templates tailored to your practice.",
        hiddenWorkflowsTitle: "Hidden Workflows",
        hiddenWorkflowsDesc: "Built-in workflows you've hidden will appear here. You can unhide them at any time.",
        emptyDesc: "Automate document analysis with reusable prompts and tabular review templates.",
        myCreation: "Myself",
        sharedFallback: "Shared",
        importTitle: "Import workflows from JSON",
        editWorkflow: "Edit workflow",
        practiceAreaPlaceholder: "Enter practice area…",
        creating: "Creating…",
        saving: "Saving…",
        createWorkflow: "Create workflow",
        selectWorkflow: "Select workflow",
        newChatBreadcrumb: "New Chat",
        newReviewBreadcrumb: "New Review",
        viewPage: "View Page",
        edit: "Edit",
        use: "Use",
        additionalMessage: "Message (optional)",
        additionalMessagePlaceholder: "Add any additional instructions to the workflow prompt…",
        createInProject: "Create in a project",
        selectProjectLabel: "Select project",
        selectDocumentsLabel: "Select documents",
        noMatchesFound: "No matches found",
        noDocsInProject: "No documents in this project",
        selectedCount: "{count} selected",
        startingChat: "Starting…",
        startChat: "Start Chat",
        createReview: "Create Review",
        workflowPromptLabel: "Workflow Prompt",
        columnsLabel: "Columns",
        noColumnsDefined: "No columns defined",
    },

    shared: {
        addDocuments: "Add Documents",
        uploadFiles: "Upload files",
        noDocumentsAvailable: "No documents available",
        people: "People",
        shareWith: "Share with",
        addByEmail: "Add by email…",
        owner: "Owner",
        viewer: "Viewer",
        removeAccess: "Remove access",
        versionUploadTitle: "Upload New Version",
        versionFile: "File",
        versionNote: "Version note",
        versionNotePlaceholder: "What changed in this version?",
        uploading: "Uploading…",
        uploadVersion: "Upload Version",
        peopleWithAccess: "People with Access",
        noOneHasAccess: "No one has access yet.",
        remove: "Remove",
        versionNameLabel: "New version name",
        versionCurrentLabel: "Current Version",
        versionNewFileLabel: "New Version File",
        changeFile: "Change file",
        newSubfolder: "New subfolder",
        download: "Download",
        showAllVersions: "Show all versions",
        uploadNewVersion: "Upload new version",
        removeFromFolder: "Remove from subfolder",
        editCmNumber: "Edit CM No.",
    },

    laura: {
        title: "LAURA Audits",
        newAudit: "New audit",
        empty: "No audits yet. Create one to start the P0–E8 audit lifecycle.",
        projectRequired: "Open a project to create a LAURA audit.",
        p0Title: "P0 — Case Contextualisation",
        p0Phase: "Phase",
        p0PhasePlanning: "PLANNING",
        p0Step: "Step",
        p0Progress: "Progress",
        p0Deliverable: "Deliverable",
        p0DeliverablePending: "Initial Briefing pending",
        p0DeliverableDone: "Initial Briefing",
        p0ContextTitle: "Initial context",
        p0SelectDocs: "Project documents",
        p0SelectDocsHint: "Select at least one document to generate questions.",
        p0InitialComments: "Initial comments (optional)",
        p0InitialCommentsPlaceholder:
            "Describe the case, audit motivation, hypotheses…",
        p0LinkedDocs: "Linked documents",
        p0GenerateQuestions: "Generate questions",
        p0GenerateBriefing: "Generate initial briefing",
        p0Generating: "Generating…",
        p0QuestionsTitle: "Clarification questions",
        p0QuestionsEmpty: 'Click "Generate questions" after linking documents.',
        p0BriefingTitle: "Initial Case Briefing",
        p0BriefingEmpty:
            'Fill in all answers, then click "Generate initial briefing".',
        p0ValidationTitle: "Validation points before advancing to P1",
        p0ValidationEmpty: "Items appear after the briefing is generated.",
        p0WaitingAnswer: "Waiting…",
        p0CategoryObjeto: "Object and context",
        p0CategoryEscopo: "Type and scope",
        p0CategoryProblema: "Problem and objectives",
        p0CategoryRecursos: "Resources and constraints",
        p0CategoryComplementar: "Additional information",
        p0InvalidateTitle: "Change context?",
        p0InvalidateMessage:
            "This will invalidate generated questions, answers, and the briefing. Continue?",
        p0InvalidateConfirm: "Continue",
        p0InvalidateCancel: "Cancel",
        p0ChatHint:
            "Use chat for questions or section edits to the briefing. Clarification Q&A is only in the form.",
        p0ChatEmpty:
            "To start an audit: link project documents, add optional comments, then click Generate questions.",
        p0ApprovedAt: "Approved on {date} by {user}",
        p0SaveComments: "Save comments",
        p0WorkflowTitle: "P0 workflow — follow these steps in order",
        p0Step1Help: "Select relevant project documents in Initial context.",
        p0Step2Help: "Optional: add initial comments about the case.",
        p0Step3Help: "Save comments (or they save when you leave the field).",
        p0Step4Help: "Click Generate questions.",
        p0Step5Help: "Answer every clarification question in the left panel.",
        p0Step6Help: "Click Generate initial briefing, then review or edit it.",
        p0Step7Help:
            "Check all validation points, then Approve & advance at the bottom.",
        p0ContextExpand: "Show initial context",
        p0ContextCollapse: "Hide initial context",
        p0ContextSummary:
            "Initial context · {count} document(s) · comments {commentsStatus}",
        p0CommentsSaved: "saved",
        p0CommentsUnsaved: "unsaved",
        p0ApproveStep: "Final step",
        p0ApproveAndAdvance: "Approve & advance",
        dashboardTitle: "LAURA Dashboard",
        statActive: "Active audits",
        statInProgress: "Planning in progress",
        statPlanningDone: "Planning completed",
        statPending: "In planning phase",
        planningProgress: "Planning progress",
        planningProgressStep: "Step {current} of {total}",
        tabInputs: "Inputs",
        tabValidation: "Validation",
        validationPending: "Human-in-the-loop QA pending",
        validationHint: "Confirm each checkpoint before approving this stage.",
        validationEmpty: "No validation checkpoints yet",
        validationGenerateHint: "Generate the deliverable with AI to populate validation checkpoints.",
        createSampleAudit: "Create NHAI sample audit",
        seedingAudit: "Seeding sample data…",
        lastUpdated: "Last updated",
        saveForm: "Save form",
        saveDeliverable: "Save deliverable",
        deliverable: "Deliverable",
        validationTitle: "Validation points",
        p1Title: "P1 — Audit Canvas",
        p2Title: "P2 — Subject Matter Overview",
        p3Title: "P3 — Risk Matrix",
        p4Title: "P4 — Audit Design Matrix",
        p5Title: "P5 — Data Collection Instruments",
        p6Title: "P6 — Audit Plan",
        p7Title: "P7 — Quality Review",
        generateCanvas: "Generate canvas",
        generateOverview: "Generate overview",
        generateRisks: "Generate risk matrix",
        generateMatrix: "Generate design matrix",
        generateInstruments: "Generate instruments",
        generatePlan: "Generate audit plan",
        generateQuality: "Generate quality review",
        addRisk: "Add risk",
        mandatoryGate: "Mandatory gate — supervisor approval required before E0",
        executiveSummary: "Executive summary",
        financialBenefits: "Financial benefits",
        nonFinancialBenefits: "Non-financial benefits",
        p1_subject: "Subject matter",
        p1_criteria: "Criteria",
        p1_evidence: "Evidence strategy",
        p1_problem: "Audit problem",
        p1_stakeholders: "Stakeholders",
        p1_assurance: "Assurance level",
        p1_objective: "SMART objective",
        p1_outOfScope: "Out of scope",
        p1_scope: "Scope",
        p1_engRisks: "Engagement risks",
        p1_deliverables: "Deliverables",
        p1_timeline: "Timeline",
        p1_benefits: "Expected benefits",
        p2_mandate: "Purpose and legal basis",
        p2_financialChart: "Financial trend",
        p2_swot: "SWOT analysis",
        p2_org: "Organisational structure",
        p2_process: "Process map",
    },
} as const;
